import { isNewLayoutsMigrated } from '@goldcast/player-config/src/utils/clipUtils';
import Button from '@/components/atoms/Button/Button';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { migrateToNewLayouts } from '@/stores/clip';

/**
 * Shown below the aspect ratio options in the new layouts popover when the clip hasn't
 * been migrated to use the new layouts engine yet (`asset_metadata.is_new_layouts_migrated`
 * is falsy). Clicking "Migrate project" flips that flag to `true` via `updateClipData`,
 * which routes to the split/non-split update path automatically.
 */
const ClipCustomizerNewLayoutsMigrateNudge = () => {
  const { clipId, clipData } = useClipsContext();

  if (isNewLayoutsMigrated(clipData)) {
    return null;
  }

  return (
    <div className="rounded-md border border-black border-opacity-10 bg-orange-50 px-3 py-2.5 text-sm">
      <div className="font-medium">Legacy project</div>
      <div className="mt-1 font-light">In order to use new layouts in editor, the project needs to be migrated.</div>
      <Button
        className="mt-2"
        variation="filled"
        trackingId="migrate-project-new-layouts-nudge"
        onClick={() => {
          migrateToNewLayouts(clipId);
        }}
      >
        Migrate project
      </Button>
    </div>
  );
};

export default ClipCustomizerNewLayoutsMigrateNudge;
